import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M57.57 107.36c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51-28.166 0-51 22.834-51 51 0 28.167 22.834 51 51 51"
    />
    <path fill="#0597A3" d="M28.07 75.31a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m92.26 92.43 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM19 96.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M23.13 12.82h-5.57V7.25c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H8.99c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M97.92 32.39c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#001A43"
      d="M72.22 89.63c-1.61-8.96-3.88-9.59-4.15-19.62s2.27-12.58 2.27-12.58H48.4s2.54 2.54 2.28 12.58-2.54 10.66-4.15 19.62.8 19.53 12.84 19.53 14.45-10.57 12.84-19.53zM59.38 99.7c-3.05 0-5.51-2.47-5.51-5.51s2.47-5.51 5.51-5.51 5.51 2.47 5.51 5.51-2.47 5.51-5.51 5.51"
    />
    <path
      fill="#00D8D8"
      d="M79.5 3.55H36.84c-1.97 0-3.56 1.59-3.56 3.56v27.05h49.77V7.1c0-1.97-1.59-3.56-3.56-3.56z"
    />
    <path
      fill="#0597A3"
      d="M33.28 34.15v17.16a6.12 6.12 0 0 0 6.12 6.12h37.53a6.12 6.12 0 0 0 6.12-6.12V34.15z"
    />
    <mask
      id="enrichedIcon-PaintbrushInverted_svg__a"
      width={51}
      height={32}
      x={33}
      y={3}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path fill="#fff" d="M83.05 3.55H33.28v30.6h49.77z" />
    </mask>
    <g fill="#0597A3" mask="url(#enrichedIcon-PaintbrushInverted_svg__a)">
      <path d="M45.06 26.23c-1.24 0-2.25-1.01-2.25-2.25V3.54c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v20.44c0 1.24-1.01 2.25-2.25 2.25M53.35 21.41c-1.24 0-2.25-1.01-2.25-2.25V3.54c0-1.24 1.01-2.25 2.25-2.25S55.6 2.3 55.6 3.54v15.62c0 1.24-1.01 2.25-2.25 2.25" />
    </g>
  </svg>
);
const SvgEnrichedIconPaintbrushInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconPaintbrushInverted);
export default Memo;
